import { supplychainAxios } from 'Utility';

export const postFilter = query => supplychainAxios.post('batches/filter', query).then(r => r.data);

export const getAllActs = () => supplychainAxios.get('acts/all').then(r => r.data);
